import { styled } from "styled-components";

export const ContextMenuWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 200px;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.background.layers[700]};
  padding: ${({ theme }) => theme.spacing[2]};
  box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.5);
  border-radius: ${({ theme }) => theme.spacing[1]};
  animation: fadeIn 0.3s ease-in-out;
`;

export const MenuItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: ${({ theme }) => theme.spacing[2]};
  background-color: ${({ theme }) => theme.colors.background.layers[700]};
  border-radius: ${({ theme }) => theme.spacing[1]};
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.background.layers[600]};
  }
`;

export const Seperator = styled.div`
  padding-top: ${({ theme }) => theme.spacing[2]};
  margin-bottom: ${({ theme }) => theme.spacing[2]};
  border-bottom: 1px solid ${({ theme }) => theme.colors.background.layers[500]};
`;

export const MenuItemText = styled.span`
  font-size: 14px;
  transition: background-color 0.2s ease-in-out;
  padding-left: ${({ theme }) => theme.spacing[3]};
`;

export const MenuItemIcon = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const MobileLabel = styled.span`
  display: none;

  @media (max-width: 768px) {
    display: block;
  }
`;

export const DesktopLabel = styled.span`
  display: block;
  @media (max-width: 768px) {
    display: none;
  }
`;
